import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import { getMetaForPath } from "@/lib/seo";

export default function PageMeta() {
  const location = useLocation();

  useEffect(() => {
    const { title, description } = getMetaForPath(location.pathname);
    document.title = title;
    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) metaDesc.setAttribute("content", description);
  }, [location.pathname]);

  return null;
}
